import React from 'react';

import Loadable from 'react-loadable';

import { fg } from '@atlaskit/platform-feature-flags';

import type { BrowseRovoAgentsModalProps } from './index';

export const LoadableBrowseRovoAgentsModal = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_editor-ai-browse-rovo-agents-modal" */
			'./index'
		).then((mod) => mod.default) as Promise<
			React.ComponentType<React.PropsWithChildren<BrowseRovoAgentsModalProps>>
		>,
	loading: () => null,
});

export const PreloadModalComponent = ({ children }: { children?: React.ReactNode }) => {
	React.useEffect(() => {
		if (fg('platform.editor.ai-rovo-agents')) {
			LoadableBrowseRovoAgentsModal.preload();
		}
	}, []);
	return <React.Fragment>{children}</React.Fragment>;
};
